export default __webpack_public_path__ + "static/media/PayPendingNegative.26f02e59.svg";